import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import BudgetComponent from './budget/budget.component';
import { AuthService } from './service/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {
    this.show = false;
  }

  show: boolean;

  canActivate() {
    if (localStorage.getItem('projectId') && this.auth.getToken()) {
      this.show = true;
    } else {
      this.show = false;
      this.router.navigate(['/auth']);
    }
    return this.show;
  }
}



// WEBPACK FOOTER //
// ./src/app/authguard.ts